import { useEffect, useState } from 'react';
import { ContentRenderer } from '@mts/ui/content-renderer';
import { useInitialPublicData } from '../../seo/PublicBootstrap.jsx';
import PublicContentPage from './PublicContentPage.jsx';
import { requestPublicJson } from '../../services/api.js';
import { showPreferencesModal } from '../../services/cookieConsentConfig.js';

export default function LegalPolicyPage({ slug, fallback }) {
  const initial = useInitialPublicData('legal');
  const [page, setPage] = useState(initial || fallback);
  useEffect(() => {
    if (initial) { setPage(initial); return; }
    let active = true;
    requestPublicJson(`/api/legal-pages/${encodeURIComponent(slug)}`)
      .then(({ page: loadedPage }) => { if (active && loadedPage?.contentJson) setPage(loadedPage); })
      .catch(() => { /* Keep the existing bundled policy when unavailable. */ });
    return () => { active = false; };
  }, [slug, initial]);
  return <PublicContentPage eyebrow="Legal" title={page.title}>
    <ContentRenderer value={page.contentJson} className="legal-policy-content max-w-3xl" />
    {slug === 'cookie-policy' ? <button type="button" onClick={showPreferencesModal} className="btn btn-primary mt-8">Manage Cookie Preferences</button> : null}
  </PublicContentPage>;
}
